import { Card, Tabs, Typography } from 'antd';
import { useLocation, useNavigate } from 'react-router';
import { Header } from '../header/header';
import { AdminAchievements } from '../admin-page/components/live-reporting-config/achievements';
import { AdminExperience } from '../admin-page/components/live-reporting-config/experience-points';
import { PowerHourConfigContainter } from '../admin-page/components/power-hour-config/power-hour-config';
import { strings } from '../../lang';
import './gamification-settings-page.css';

const { Title, Text } = Typography;

type TabKey = 'experience-points' | 'achievements' | 'power-hour';

const tabPaths: Record<TabKey, string> = {
  'experience-points': '/gamification-config/experience-points',
  achievements: '/gamification-config/achievements',
  'power-hour': '/gamification-config/power-hour',
};

const getActiveTab = (pathname: string): TabKey => {
  const entry = (Object.entries(tabPaths) as [TabKey, string][]).find(([, path]) => path === pathname);
  return entry?.[0] ?? 'experience-points';
};

const SettingInformation = ({ tab }: { tab: TabKey }) => {
  const details = {
    'experience-points': strings.gamificationSettings.experiencePoints,
    achievements: strings.gamificationSettings.achievements,
    'power-hour': strings.gamificationSettings.powerHour,
  }[tab];

  return (
    <Card className="gamification-settings-page__information" size="small">
      <div className="gamification-settings-page__information-title">{strings.gamificationSettings.about}</div>
      <p><strong>{strings.gamificationSettings.whatYouCanChange}</strong> {details.whatYouCanChange}</p>
      <p><strong>{strings.gamificationSettings.whatUsersExperience}</strong> {details.whatUsersExperience}</p>
      {'note' in details && details.note && <p><strong>{strings.gamificationSettings.important}</strong> {details.note}</p>}
      {'timezoneNote' in details && details.timezoneNote && <p><strong>{strings.gamificationSettings.timezone}</strong> {details.timezoneNote}</p>}
    </Card>
  );
};

export const GamificationSettingsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = getActiveTab(location.pathname);

  return (
    <>
      <Header />
      <main className="gamification-settings-page">
        <div className="gamification-settings-page__heading">
          <div>
            <Title level={2}>
              {strings.gamificationSettings.title}
            </Title>
            <Text type="secondary">
              {strings.gamificationSettings.description}
            </Text>
          </div>
        </div>
        <Tabs
          activeKey={activeTab}
          onChange={(key) => navigate(tabPaths[key as TabKey])}
          items={[
            { key: 'experience-points', label: strings.gamificationSettings.experiencePointsTab, children: <><SettingInformation tab="experience-points" /><AdminExperience /></> },
            { key: 'achievements', label: strings.gamificationSettings.achievementsTab, children: <><SettingInformation tab="achievements" /><AdminAchievements /></> },
            { key: 'power-hour', label: strings.gamificationSettings.powerHourTab, children: <><SettingInformation tab="power-hour" /><PowerHourConfigContainter /></> },
          ]}
        />
      </main>
    </>
  );
};
